import React from 'react';

function Path(props){
    const pathMapper = props.path.map((list=>{
        return (
            <path key={list.entry.id}
                  id={list.entry.id}
                  d="M0 0"
                  stroke={list.entry.colour}
                  fill="none"
                  strokeWidth="2px"/>
          )
    }))
    return (
        <div id="svgContainer">
            <svg id="svg1" width="0" height="0">
                {pathMapper}
            </svg>
        </div>
    )
}
export default Path;


// WEBPACK FOOTER //
// ./src/components/path/path.js